/**
 * Check if a specific court + time range is available.
 *
 * @param courtId - The court to check
 * @param startTime - Start of the time range
 * @param endTime - End of the time range
 * @param existingBookings - Array of bookings to check against
 * @param excludeBookingId - Booking ID to exclude (e.g. the booking being moved)
 * @returns { available, conflictingBooking } - Whether the slot is free and the conflicting booking if not
 */
export function checkSlotAvailability(
  courtId: string,
  startTime: Date,
  endTime: Date,
  existingBookings: Array<{ court_id: string; start_time: string; end_time: string; status: string; id: string }>,
  excludeBookingId?: string,
): { available: boolean; conflictingBooking?: typeof existingBookings[0] } {
  const conflict = existingBookings.find(
    (b) =>
      b.court_id === courtId &&
      b.id !== excludeBookingId &&
      b.status !== "cancelled" &&
      new Date(b.start_time) < endTime &&
      new Date(b.end_time) > startTime,
  );
  return conflict
    ? { available: false, conflictingBooking: conflict }
    : { available: true };
}
